import api from '../api/bikePartsApi';
import {actions as notificationActions} from './notificationActions';
import * as logger from '../utils/logger';

export const types = {
  GET_BIKE_PARTS: 'GET_BIKE_PARTS',
  GET_BIKE_PARTS_SUCCESS: 'GET_BIKE_PARTS_SUCCESS',
  GET_BIKE_PARTS_FAILURE: 'GET_BIKE_PARTS_FAILURE',
  CREATE_BIKE_PART_SUBMIT: 'CREATE_BIKE_PART_SUBMIT',
  CREATE_BIKE_PART_SUCCESS: 'CREATE_BIKE_PART_SUCCESS',
  CREATE_BIKE_PART_FAILURE: 'CREATE_BIKE_PART_FAILURE',
  DELETE_BIKE_PART_SUBMIT: 'DELETE_BIKE_PART_SUBMIT',
  DELETE_BIKE_PART_SUCCESS: 'DELETE_BIKE_PART_SUCCESS',
  DELETE_BIKE_PART_FAILURE: 'DELETE_BIKE_PART_FAILURE',
  GET_SERVICE_PARTS_REPORT: 'GET_SERVICE_PARTS_REPORT',
  GET_SERVICE_PARTS_REPORT_SUCCESS: 'GET_SERVICE_PARTS_REPORT_SUCCESS',
};


export const actions = {
  getAll: () => (dispatch) => {
    dispatch({type: types.GET_BIKE_PARTS});
    return api.getAll().then(res => {
      if (res.ok) {
        dispatch({type: types.GET_BIKE_PARTS_SUCCESS, result: res.data || []});
      } else {
        dispatch({type: types.GET_BIKE_PARTS_FAILURE, result: []});
      }
    });
  },

  create: name => (dispatch) => {
    dispatch({type: types.CREATE_BIKE_PART_SUBMIT, name});

    return api.create(name).then(res => {
      if (res.ok) {
        dispatch({type: types.CREATE_BIKE_PART_SUCCESS, id: res.data, name});
        dispatch(notificationActions.showSuccess('Część została dodana do katalogu'));
        return true;
      } else {
        dispatch({type: types.CREATE_BIKE_PART_FAILURE});
        dispatch(notificationActions.showError('Wystąpił problem podczas dodawania części do katalogu'));
        return logger.error(res.data);
      }
    });
  },

  delete: id => (dispatch) => {
    dispatch({type: types.DELETE_BIKE_PART_SUBMIT, id});
    return api.delete(id).then(res => {
      if (res.ok) {
        dispatch({type: types.DELETE_BIKE_PART_SUCCESS, id});
        dispatch(notificationActions.showSuccess('Część została usunięta z katalogu'));
      } else {
        dispatch({type: types.DELETE_BIKE_PART_SUBMIT, id});
        dispatch(notificationActions.showError('Wystąpił problem podczas usuwania części z katalogu'));
        return logger.error(res.data);
      }
    });
  },
};
